<template>
  <div>
    <AppLoader v-if="isLoading" class="text-center" small />

    <b-row class="p-5" style="height: calc(100vh - 100px);overflow-y:auto;">
      <b-col cols="12">
        <b-button-group class="float-right">
          <b-button variant="outline-warning">Refer to Exthibase</b-button>
          <b-button variant="outline-success">ORDER EDD</b-button>
        </b-button-group>
        <div class="clearfix"></div>

        <h3>
          False Positive Report Remediation&nbsp;
          <small class="text-muted">Instant Due Diligence Plus</small>
        </h3>
        <b-tabs>
          <b-tab title="Report Overview">
            <b-row class="p-5">
              <b-col cols="3">
                <b-card>
                  <b-card-text>
                    <strong>Date:</strong>
                    <br />
                    {{report.inserted_date}}
                  </b-card-text>
                  <b-card-text>
                    <strong>Report Type:</strong>
                    <br />
                    {{report.report_type == 1 ? 'Instant Due Diligence' : 'Instant Due Diligence Plus' }}
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col cols="3">
                <b-card>
                  <b-card-text>
                    <strong>Third Party Name:</strong>
                    <br />
                    {{report.srch_name}}
                  </b-card-text>
                  <b-card-text>
                    <strong>Jurisdiction:</strong>
                    <br />
                    {{report.shield_vendor_infos.country || 'All'}}
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col cols="3">
                <b-card>
                  <b-card-text>
                    <strong>Entity Type:</strong>
                    <br />
                    <font-awesome-icon
                      :icon="report.srch_type== 'O' ? 'building' : 'male'"
                      class="mr-2"
                    />
                  </b-card-text>
                  <b-card-text>
                    <strong>Number of Associates:</strong>
                    <br />
                    {{report.shield_vendor_infos.srch_tpi_assos.length}}
                  </b-card-text>
                </b-card>
              </b-col>
              <b-col cols="3">
                <b-card>
                  <b-card-text>
                    <strong>PRI</strong>
                    <br />
                    <PRI :pri="parseInt(report.shield_vendor_infos.ethix_risk_rating)"></PRI>
                    <br />
                  </b-card-text>
                  <b-card-text>
                    <strong>Download Report:</strong>
                    <br />
                    <font-awesome-icon class="text-danger" icon="file-pdf" />
                  </b-card-text>
                  <b-card-text>
                    <strong>Total Entities With Alerts:</strong>
                    <br />
                    <b-badge variant="primary">{{noOfEntitiesWithAlerts}}</b-badge>
                  </b-card-text>
                </b-card>
              </b-col>
            </b-row>
            <entityOverview
              v-if="dataLoaded"
              class="p-3 mb-1"
              style="border:solid 1px #DFDFDF;"
              :entityData="report.shield_vendor_infos"
            ></entityOverview>

            <div
              v-if="dataLoaded"
              v-for="(associate,associateIndex) in report.shield_vendor_infos.srch_tpi_assos"
              :key="associateIndex"
            >
              <associateOverview
                class="p-3 mb-1"
                style="border:1px solid #DFDFDF;"
                v-if="associate.srch_asso_rdc_indivi_alrt.length"
                :associate="associate"
                :key="associateIndex"
              ></associateOverview>
            </div>
          </b-tab>
          <!-- -------------------- -->
          <b-tab>
            <template
              v-slot:title
            >All Entities ({{report.shield_vendor_infos.srch_tpi_assos.length + 1}})</template>
            <entityOverview
              class="p-3 mb-1"
              style="border:solid 1px #DFDFDF;"
              :entityData="report.shield_vendor_infos"
            ></entityOverview>

            <div
              v-for="(associate,associateIndex) in report.shield_vendor_infos.srch_tpi_assos"
              :key="associateIndex"
            >
              <associateOverview
                class="p-3 mb-1"
                style="border:1px solid #DFDFDF;"
                :associate="associate"
                :key="associateIndex"
              ></associateOverview>
            </div>
          </b-tab>
          <!-- --------------- -->
          <b-tab>
            <template v-slot:title>Alerts ({{totalAlerts}}) Overveiw</template>
            <AlertsTabe v-if="report.shield_vendor_infos.srch_tpi_assos.length" :allAlerts="report.shield_vendor_infos" />
            
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>

    <b-navbar toggleable="lg" type="dark" variant="dark" fixed="bottom">
      <b-navbar-brand href="#">Total Alerts: {{$store.state.totalAlerts}}</b-navbar-brand>
      <b-navbar-brand href="#">Remediated Alerts: {{$store.state.totalRemidiatedAlerts}}</b-navbar-brand>
      <b-navbar-brand href="#">Pending: {{$store.state.totalPendingAlerts}}</b-navbar-brand>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-form>
            <b-button size="sm" class="my-2 my-sm-0" type="button" variant="danger">Order EDD</b-button>
            <b-button
              size="sm"
              class="my-2 my-sm-0"
              type="button"
              variant="warning"
            >Refer to ethixBase</b-button>
            <b-button size="sm" class="my-2 my-sm-0" type="button" variant="primary">Save As Draft</b-button>
            <b-button size="sm" class="my-2 my-sm-0" type="button" variant="success">Complete</b-button>
          </b-nav-form>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
import { HTTP } from "../utils/HTTP";
import AppLoader from "../components/Loader/Loader";

import entityOverview from "../components/remediation/entity-overview.vue";
import AlertsTabe from "../components/remediation/alerts-overview-table.vue";
import associateOverview from "../components/remediation/associate-overview.vue";
import PRI from "../components/remediation/pri.vue";
import vSelect from "vue-select";
import _ from "lodash";

export default {
  name: "remediationAsAService",
  components: {
    vSelect,
    associateOverview,
    entityOverview,
    PRI,
    AppLoader,
    AlertsTabe
  },
  data() {
    return {
      isLoading: false,
      dataLoaded: false,
      report: {
        shield_vendor_infos: {
          country: null,
          srch_tpi_assos: []
        }
      },

      //for entities with alert
      noOfEntitiesWithAlerts: 0,
      totalAlerts: 0
    };
  },
  mounted() {
    this.getAlerts();
  },
  methods: {
    async getAlerts() {
      let token = "Bearer " + localStorage.getItem("accessToken");
      this.items = [];
      this.$store.state.totalPendingAlerts = 0;
      this.$store.state.totalAlerts = 0;
      this.$store.state.totalRemidiatedAlerts = 0;

      this.totalAlerts = 0;
      try {
        this.isLoading = true;
        let result = await HTTP(
          "GET",
          "v1/remediation/alerts",
          {},
          {
            Authorization: token
          },
          null,
          true
        );
        this.report = result.data.report; //  get an object in response
        this.dataLoaded = true;
        // // console.log('report---',this.report.shield_vendor_infos);
        if (
          this.report.shield_vendor_infos.srch_tpi_rdc_indivi_alrt.length > 0
        ) {
          this.$store.state.totalAlerts += this.report.shield_vendor_infos.srch_tpi_rdc_indivi_alrt.length; // sum of investments in store
          this.totalAlerts += this.report.shield_vendor_infos.srch_tpi_rdc_indivi_alrt.length; // sum of investments
          // console.log("--0--")
          this.$store.state.totalPendingAlerts += this.report.shield_vendor_infos.srch_tpi_rdc_indivi_alrt.length; // sum of investments in store
          this.noOfEntitiesWithAlerts++;
        }
        let assosiateWithAlerts = this.report.shield_vendor_infos.srch_tpi_assos;
        this.calculateNoOfEntitiesWithAlerts(assosiateWithAlerts);

        this.isLoading = false;
      } catch {
        this.isLoading = false;
        this.showErrorToast = true;
      }
    },
    calculateNoOfEntitiesWithAlerts(assosiates) {
      assosiates.map(assosiate => {
        if (assosiate.srch_asso_rdc_indivi_alrt.length > 0) {
          // // console.log("assosiate.srch_asso_rdc_indivi_alrt.length", assosiate.srch_asso_rdc_indivi_alrt.length);
          this.totalAlerts += assosiate.srch_asso_rdc_indivi_alrt.length; // calculate all assosiate's sum
          this.$store.state.totalAlerts +=
            assosiate.srch_asso_rdc_indivi_alrt.length; // in store
          this.$store.state.totalPendingAlerts +=
            assosiate.srch_asso_rdc_indivi_alrt.length; //in store
          this.noOfEntitiesWithAlerts++;
        }
      });
    }
  }
};
</script>

<style scoped>
.pri-row {
  height: calc(100vh - 150px);
  overflow-y: scroll;
}
</style>
